import { useLayoutEffect, useRef, type ReactNode } from "react";
import { useLocation } from "react-router";

export interface MainProps {
    children: ReactNode;
    title?: string;
}

/** 主内容容器，统一保留旧 Vue 页面内容区的滚动和内边距入口。 */
export function Main({ children, title }: MainProps) {
    const location = useLocation();
    const mainRef = useRef<HTMLElement>(null);

    useLayoutEffect(() => {
        /** 路由页签可能复用表格节点，进入页面时必须恢复旧 Vue 从首列开始的初始位置。 */
        const resetTableHorizontalScroll = () => {
            mainRef.current
                ?.querySelectorAll<HTMLElement>(".zh-table .ant-table-body, .zh-table .ant-table-content")
                .forEach(scrollContainer => {
                    scrollContainer.scrollLeft = 0;
                });
        };

        resetTableHorizontalScroll();
        const animationFrame = window.requestAnimationFrame(resetTableHorizontalScroll);
        return () => window.cancelAnimationFrame(animationFrame);
    }, [location.key, location.pathname, location.search]);

    return (
        <main ref={mainRef} className="layout-main-container">
            {title ? <div className="route-title">{title}</div> : null}
            {children}
        </main>
    );
}

export default Main;
